import script from "./CRMReportEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./CRMReportEditor.vue?vue&type=script&setup=true&lang=js"

import "./CRMReportEditor.vue?vue&type=style&index=0&id=4e45f4f6&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e45f4f6"]])

export default __exports__